import React from "react";
import OurTeam from "./OurTeam";
import WhyDiksha from "./WhyDiksha";
import AboutPage from "./AboutPage";
import Testimonial from "./Testimonial";
import VisionMission from "./VisionMission";
import { Link } from "react-router-dom";

const AboutSection = () => {
  return (
    <>
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: "400px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="img-fluid position-absolute w-100 h-100"
                  src="img/welcome_to_diksha.png"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h6 className="section-title bg-white text-start text-primary pe-3">
                About Us
              </h6>

              {/* <h1 class="mb-4">Your Path to Success Starts Here!</h1> */}
              <h1
                className="mb-4"
                style={{ fontSize: "28px", fontWeight: "bold" }}
              >
                Empowering Your IT Career at Diksha SEA – Leading Software
                Training Institute in Tirupati
              </h1>
              <p className="mb-4">
                Diksha SEA is a new initiation of Diksha with an objective to
                place students across the globe. Diksha empowers students with
                innovative mentor-based skilled training programs that bring out
                the best abilities of the students to be versed with emerging
                trends in technologies, domain and tools to build up a best
                carrer for the future.
              </p>
              <p className="mb-4">
                At Diksha SEA, We are a rapidly growing institute established in
                2009, in the temple town Tirupati in the state of Andhra
                Pradesh. We started with the sole intention of providing
                best-in-class, cost effective IT services and enterprise
                solutions. Our core competency is the management of professional
                employees.
              </p>
              {/* <div className="row gy-2 gx-4 mb-4">
                {[
                  "Skilled Instructors",
                  "Offline Classes",
                  "Course Completion Certificate",
                ].map((item, index) => (
                  <div key={index} className="col-sm-6">
                    <p className="mb-0">
                      <i className="fa fa-arrow-right text-primary me-2"></i>
                      {item}
                    </p>
                  </div>
                ))}
              </div> */}
              <Link className="btn btn-primary py-3 px-5 mt-2" to="">
                Read More
              </Link>
            </div>
          </div>
        </div>
      </div>

      <WhyDiksha />
      <VisionMission />
      <OurTeam />
      <Testimonial />
    </>
  );
};

export default AboutSection;
